/**
 * ItemList JSON-LD for the freelancer cards shown on a skill SEO page.
 *
 * Each entry is a light Person node whose @id matches the mainEntity Person
 * on that freelancer's profile page (`<profileUrl>#person`, see
 * ProfilePage/profileSchema.js), so the skill pages and the profile pages
 * link into one entity graph instead of describing disjoint entities.
 *
 * freelancers: [{ profileUrl, displayName, imageUrl, knowsAbout,
 *                 locationCity, locationCountryCode }]
 */
export const buildFreelancerItemListSchema = (freelancers = []) => {
  const items = freelancers.filter(f => f.profileUrl && f.displayName);
  if (items.length === 0) {
    return null;
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    numberOfItems: items.length,
    itemListElement: items.map((f, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@type': 'Person',
        '@id': `${f.profileUrl}#person`,
        name: f.displayName,
        url: f.profileUrl,
        ...(f.imageUrl && { image: f.imageUrl }),
        ...(f.knowsAbout?.length > 0 && { knowsAbout: f.knowsAbout }),
        ...(f.locationCity && {
          address: {
            '@type': 'PostalAddress',
            addressLocality: f.locationCity,
            ...(f.locationCountryCode && { addressCountry: f.locationCountryCode }),
          },
        }),
      },
    })),
  };
};
